export const getUser = (state) => state.authentication.user;
export const getIsLoggedIn = (state) => state.authentication.loggedIn;
